import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SKIP_GLOBAL_LOADING } from '../consts/http-context.tokens';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loading = inject(LoadingService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldTrack =
      req.url.startsWith(environment.urlApi) && !req.context.get(SKIP_GLOBAL_LOADING);

    if (!shouldTrack) {
      return next.handle(req);
    }

    this.loading.show();

    return next.handle(req).pipe(
      finalize(() => {
        this.loading.hide();
      }),
    );
  }
}
